import './new-hotel.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormHotel from "../form-hotel/form-hotel";
import { useNewHotel } from './new-hotel.hook';

export function NewHotel() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewHotel();

  return (
    <div id="NewHotel" className="hotel">
      <HeaderContent
        title={<h1>New Hotel</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormHotel />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewHotel;